import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { KEYCLOAK_LOGIN_USER, KEYCLOAK_LOGOUT_USER } from "../actions";
import {
  keycloakLoginUserSuccess,
  keycloakLoginUserError,
  keycloakLogoutUser,
} from "./actions";
import axios from "../../helpers/Axios";
import { post } from "axios";
import { apiPath } from "../../constants/defaultValues";
import { processors, reclassify } from "../../assets/data/reprocessors";

const loginUserAsync = async (payload, isAdmin) => {
  if (isAdmin) {
    return post(`${apiPath}/authentication/keycloak/token/`, {
      access_token: payload.access_token,
      role: "Employee",
    })
      .then((res) => res)
      .catch((error) => error);
  }

  return post(`${apiPath}/authentication/esecure/token/`, {
    keycloak_id: payload.keycloak_id,
    access_token: payload.access_token,
    has_compass: true,
  })
    .then((res) => res)
    .catch((error) => error);
};

function* loginWithIdToken({ payload }) {
  const { user, history, isAdmin } = payload;

  try {
    const loginUser = yield call(loginUserAsync, user, isAdmin);

    if (!loginUser.message) {
      // login
      yield put(keycloakLoginUserSuccess(loginUser.data));
    } else {
      const status = loginUser.response?.status;
      const message = loginUser.response?.data?.message || "Failed to Login!";

      if (
        !isAdmin && // enrollment flow (for users only)
        status === 404 &&
        message.includes("No user found")
      ) {
        yield put(keycloakLoginUserError(message));
        setTimeout(() => history.push("/user/enrollment"), 2000);
      } else {
        const errorDescription = loginUser.response?.data?.error_description;
        yield put(keycloakLoginUserError(message));
        if (errorDescription) {
          localStorage.setItem("validation", errorDescription);
        }
      }
    }
  } catch (error) {
    yield put(
      keycloakLoginUserError(error.message || "Unexpected error occurred.")
    );
  }
}

// const loginWithIdTokenAsync = async (keycloak_id, access_token) =>
//   post(`${apiPath}/authentication/esecure/token/`, {
//     keycloak_id: keycloak_id,
//     access_token: access_token,
//   })
//     .then((keycloakAuthUser) => keycloakAuthUser)
//     .catch((error) => error);

// function* loginWithIdToken({ payload }) {
//   const { keycloak_id, access_token } = payload.user;
//   const { history } = payload;

//   try {
//     const loginUser = yield call(
//       loginWithIdTokenAsync,
//       keycloak_id,
//       access_token
//     );

//     if (!loginUser.message) {
//       // successful login
//       yield put(keycloakLoginUserSuccess(loginUser.data));
//     } else {
//       const status = loginUser.response?.status;
//       const message = loginUser.response?.data?.message || "Failed to Login!";

//       // handle 404 - no eFast enrollment
//       if (
//         status === 404 &&
//         message ===
//           "No user found with Company or Filer role for this eSecure account. Please register using eFast website."
//       ) {
//         yield put(keycloakLoginUserError(message));
//         setTimeout(() => {
//           history.push("/user/enrollment");
//         }, 2000);
//       } else {
//         // handle 400 (validation)
//         const errorDescription = loginUser.response?.data?.error_description;
//         yield put(keycloakLoginUserError(message));
//         if (errorDescription) {
//           localStorage.setItem("validation", errorDescription);
//         }
//       }
//     }
//   } catch (error) {
//     yield put(
//       keycloakLoginUserError(error.message || "Unexpected error occurred.")
//     );
//   }
// }

// function* loginWithIdToken({ payload }) {
//   const { keycloak_id, access_token } = payload.user;
//   const { history } = payload;

//   try {

//     const loginUser = yield call(loginWithIdTokenAsync, keycloak_id, access_token);

//     if (!loginUser.message) {
//       yield put(keycloakLoginUserSuccess(loginUser.data));
//       // history.push("/");
//     } else {
//       if (loginUser.message) {
//         const message = loginUser.response.data;
//         if (message.message) {
//           yield put(keycloakLoginUserError(message.message));
//           localStorage.setItem("validation", message.error_description);
//         } else {
//           yield put(keycloakLoginUserError("Failed to Login!"));
//         }
//       } else {
//         yield put(keycloakLoginUserError("Failed to Login!"));
//       }
//     }
//   } catch (error) {
//     yield put(keycloakLoginUserError(error));
//   }
// }

function* logout({ payload }) {
  const { history, auth } = payload;

  try {
    yield call([auth, auth.signoutRedirect], {
      id_token_hint: auth.user?.id_token,
      // post_logout_redirect_uri: "http://localhost:3000/",
      // post_logout_redirect_uri: "https://efast.dev.comclark.tech/",
      // post_logout_redirect_uri: "https://efast.sec.gov.ph/",
      // post_logout_redirect_uri: "https://efast.uat.comclark.tech/",

      // this shows esecure logout page
      post_logout_redirect_uri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI_PROD
      // REACT_APP_POST_LOGOUT_REDIRECT_URI_DEV_LOCAL
      // REACT_APP_POST_LOGOUT_REDIRECT_URI_DEV_REMOTE
      // REACT_APP_POST_LOGOUT_REDIRECT_URI_UAT
      // REACT_APP_POST_LOGOUT_REDIRECT_URI_PROD
    });

    yield put(keycloakLogoutUser(history));

    history.push("/");
  } catch (error) {
    console.error("Logout failed:", error);
  }
}

export function* watchKeycloakLoginUser() {
  yield takeEvery(KEYCLOAK_LOGIN_USER, loginWithIdToken);
}

export function* watchKeycloakLogoutUser() {
  yield takeEvery(KEYCLOAK_LOGOUT_USER, logout);
}

export default function* rootSaga() {
  yield all([fork(watchKeycloakLoginUser), fork(watchKeycloakLogoutUser)]);
}
